<template>
  <div class="grid gap-1">
    <label class="flex gap-2">
      <input
        v-if="name"
        v-bind="{ name }"
        type="hidden"
        :value="model ? 1 : 0"
      >

      <input
        v-model="model"
        class="
          top-1 appearance-none size-4 rounded border border-gray-400 text-blue-600 dark:text-white
          checked:bg-blue-600 checked:border-blue-600 focus:ring-blue-500 focus:ring-2 focus:ring-offset-2
        "
        type="checkbox"
        :true-value="trueValue"
        :false-value="falseValue"
      >

      <template v-if="label">
        <span class="block">{{ label }}</span>
      </template>

      <slot v-else/>
    </label>

    <p v-if="help || $slots.help" :id="aria['aria-describedby']" class="help text-sm text-gray-500">
      <slot v-if="$slots.help" name="help"/>
      <template v-else>
        {{ help }}
      </template>
    </p>
  </div>
</template>

<script setup>
import { computed, useSlots } from "vue"

const model = defineModel([Boolean, Number, String])

const props = defineProps({
  name: String,
  label: String,
  help: String,
  trueValue: { type: [Number, Boolean, String], default: true },
  falseValue: { type: [Number, Boolean, String], default: false },
})

const slots = useSlots()

const aria = computed(() => {
  const attrs = {}

  if (props.help || slots.help) {
    attrs["aria-describedby"] = `${props.id}_help`
  }

  return attrs
})
</script>

<style scoped>
input[type='checkbox']:checked {
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e")
}
</style>
